import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private socketService: SocketService
  ) { }

  login(username: any, password: any) {
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/login`, {username: username, password: password })
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        this.socketService.connect(user.data.access_token);
        return user;
      }));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + 'user');
    localStorage.removeItem('display_name');
    this.socketService.disconnect();
    this.router.navigate(['/login']);
  }


      downloadFoodGenerationExcel(fromDate: any, toDate: any,apartmentId: any, restaurant_id: any,search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/restaurant/downloadDeliveredOrd?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&apartmentId="
                +apartmentId +
                "&restaurant_id="
                +restaurant_id+
                "&search_invoiceNumber="
                +search_invoiceNumber+
                "&search_userName="
                +search_userName+
                "&search_userContactNo="
                +search_userContactNo+
                "&search_userEmail="
                +search_userEmail,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    downloadroomserviceExcel(fromDate: any, toDate: any,apartmentId: any,search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/apartment/downloadDeliveredOrd?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate+
                "&apartmentId="
                +apartmentId+
                "&search_invoiceNumber="
                +search_invoiceNumber+
                "&search_userName="
                +search_userName+
                "&search_userContactNo="
                +search_userContactNo+
                "&search_userEmail="
                +search_userEmail,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    downloadlaundrydlvryExcel(fromDate: any, toDate: any,apartmentId: any, laundryId: any,search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/laundry/downloadDeliveredOrd?fromDate=` +
                fromDate +
                "&toDate=" +
                toDate +
                "&apartmentId="
                +apartmentId+
                "&laundryId="
                +laundryId +
                "&search_invoiceNumber="
                +search_invoiceNumber+
                "&search_userName="
                +search_userName+
                "&search_userContactNo="
                +search_userContactNo+
                "&search_userEmail="
                +search_userEmail,


                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

}
